module.exports = __webpack_public_path__ + "static/media/Sector2.fcc84021.jpg";